export class OrgCreditCard {
  id: number;
  version: number;
  cardType?: string;
  cardNumber: string;
  cardHolderName: string;
  expirationMonth: string;
  expirationYear: string;
  securityCode: string;
}
